import React from 'react'
import { Alert, Button } from 'antd'
import { ErrorType } from '../../../models/aiAnalysis/workflow'
import styles from './styles.module.scss'

export interface AiDraftErrorDisplayProps {
  error: string
  errorType: ErrorType
  onDismiss: () => void
}

const BUTTON_TEXT: Record<ErrorType, string> = {
  [ErrorType.ALREADY_DECIDED]: 'Okay, got it',
  [ErrorType.RETRYABLE]: 'Try again',
  [ErrorType.FATAL]: 'Close'
}

const AiDraftErrorDisplay: React.FC<AiDraftErrorDisplayProps> = ({ error, errorType, onDismiss }) => {
  const buttonText = BUTTON_TEXT[errorType]

  return (
    <div className={styles.errorOnlyContainer}>
      <Alert message={error} type="error" showIcon className={styles.errorAlert} />
      <div className={styles.errorActions}>
        <Button onClick={onDismiss} type="primary" className={styles.errorButton}>
          {buttonText}
        </Button>
      </div>
    </div>
  )
}

export default AiDraftErrorDisplay
